<div class="flex items-center">
  <mat-checkbox [formControl]="filterControl" (change)="onChange(filterControl.value)">
    {{ label | translate }}
  </mat-checkbox>
</div>
